import $ from 'jQuery';

$('html').on('click', '[data-global-toggle]', function () {
    $('html').toggleClass($(this).attr('data-global-toggle'));
});